import { useEffect, useMemo, useState } from "react";

import { toBlob } from "components/Environment/helpers";

import { FILE_PREVIEW_MAX_SIZE } from "./constants/values";

export const useCheckFileMaxSize = (
  originalFile: string,
  maxFileSize: number = FILE_PREVIEW_MAX_SIZE
) => {
  const [fileContent, setFileContent] = useState<string>("");

  const blob = useMemo(() => toBlob(originalFile), [originalFile]);
  const isFileBroken = !blob;
  const exceedsFileSize = !isFileBroken ? blob.size > maxFileSize : false;

  useEffect(() => {
    const parseFileContent = async () => {
      if (isFileBroken || exceedsFileSize) {
        setFileContent("");
        return;
      }

      const content = await blob.text();
      setFileContent(content);
    };

    parseFileContent();
  }, [blob, exceedsFileSize, isFileBroken]);

  return {
    fileContent,
    exceedsFileSize,
    isFileBroken,
  };
};
